/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S20_Li4_CInputs */

const tr_mesafeli_s20_li4_c = /** @type {(inputs: Mesafeli_S20_Li4_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`üzerinden yapılabilir. ETBİS kaydı bir sicil bilgisidir; uyuşmazlık başvurusu veya dava kanalı değildir. Tüketici hakem heyeti başvuruları e-Devlet üzerinden Tüketici Bilgi Sistemi`)
};

const en_mesafeli_s20_li4_c = /** @type {(inputs: Mesafeli_S20_Li4_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. The ETBİS registration is registry information and not a channel for complaints or litigation. Applications to the Consumer Arbitration Committee can also be filed via e-Devlet in the Consumer Information System`)
};

const de_mesafeli_s20_li4_c = /** @type {(inputs: Mesafeli_S20_Li4_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`möglich. Der ETBİS-Eintrag ist eine Registerangabe und kein Weg für Beschwerden oder Klagen. Anträge an den Verbraucherschlichtungsausschuss können über e-Devlet im Verbraucherinformationssystem`)
};

const ru_mesafeli_s20_li4_c = /** @type {(inputs: Mesafeli_S20_Li4_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. Регистрация в ETBİS является сведениями реестра, а не каналом для подачи жалоб или исков. Обращения в Комитет по потребительским спорам можно также подать через e-Devlet в Системе информации для потребителей`)
};

/**
* | output |
* | --- |
* | ". The ETBİS registration is registry information and not a channel for complaints or litigation. Applications to the Consumer Arbitration Committee can also ..." |
*
* @param {Mesafeli_S20_Li4_CInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s20_li4_c = /** @type {((inputs?: Mesafeli_S20_Li4_CInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S20_Li4_CInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s20_li4_c(inputs)
	if (locale === "de") return de_mesafeli_s20_li4_c(inputs)
	if (locale === "ru") return ru_mesafeli_s20_li4_c(inputs)
	return tr_mesafeli_s20_li4_c(inputs)
});